// PanelWithComments — responsive two-column shell for the share viewer
// (PRD §9.5 + docs/frontend_architecture.md §6, B2 PR7 / B2g).
//
// Below 768px: stack the candidate panel (video + canvas) above the
// comment thread. At 768px and above: render side-by-side with a
// flex-1 panel column and a w-80 comment column.
//
// The wrapper carries `data-layout="stacked" | "side-by-side"` so
// vitest can assert the swap without inspecting Tailwind classnames
// (jsdom doesn't evaluate the @media tree).
//
// Lives in its own file (split from share.$token.tsx) so it can be
// rendered and tested without booting the file-route's TanStack
// machinery — same pattern as `playlistThumbs.ts`, `commentGroups.ts`,
// `annotationGeometry.ts`, etc.

import { useMediaQuery } from '../hooks/useMediaQuery';

interface PanelWithCommentsProps {
  panel: React.ReactNode;
  comments: React.ReactNode;
}

export function PanelWithComments({
  panel,
  comments,
}: PanelWithCommentsProps): React.JSX.Element {
  const wide = useMediaQuery('(min-width: 768px)');
  if (wide) {
    return (
      <div
        data-layout="side-by-side"
        className="flex flex-row gap-6"
      >
        <div className="min-w-0 flex-1">{panel}</div>
        <div className="w-80 shrink-0">{comments}</div>
      </div>
    );
  }
  return (
    <div data-layout="stacked" className="flex flex-col gap-6">
      {panel}
      {comments}
    </div>
  );
}
